import {useUpmPlantTimezone} from '@hconnect/upm'
import {SxProps, Theme} from '@mui/material'
import {OperationHoursContainer} from '@widgets/running-times'

import {useOptimizationSpecialistTimeRange} from '../hooks'

type Props = {
  plantId: string
  onEquipmentClick?: (equipmentId: string) => void
  cardBoxSx?: SxProps<Theme>
  isMobile?: boolean
  hideLegend?: boolean
}

export const OperationHoursTimeRangeContainer = ({
  plantId,
  onEquipmentClick,
  cardBoxSx,
  isMobile = false,
  hideLegend = false
}: Props) => {
  const timezone = useUpmPlantTimezone(plantId)
  const {start, end} = useOptimizationSpecialistTimeRange(plantId)

  return (
    <OperationHoursContainer
      plantId={plantId}
      from={start?.toISOString()}
      to={end?.toISOString()}
      timezone={timezone}
      clipToCurrentTime={true}
      onEquipmentClick={onEquipmentClick}
      cardBoxSx={cardBoxSx}
      isMobile={isMobile}
      hideLegend={hideLegend}
    />
  )
}
